import { render, staticRenderFns } from "./SupplierGoodsList.vue?vue&type=template&id=91b3790c&scoped=true&"
import script from "./SupplierGoodsList.vue?vue&type=script&lang=ts&"
export * from "./SupplierGoodsList.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierGoodsList.vue?vue&type=style&index=0&id=91b3790c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b3790c",
  null
  
)

export default component.exports